/**
 * Ryan O'Dowd
 * 2025-02-09
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Accordion from '@components/common/Accordion';
import React from 'react';
import fb from '@utils/firebase';
// @TODO: import getStyles from './styles';
// @TODO: import hooks from '@hooks';

// @TODO: const PremiumBadge = <View>Schools only</View>; // @TODO: import PremiumBadge from '@components/PremiumBadge'; // @TODO: this should be a school/teacher badge or something

const Faq = (props: FaqProps) => {
  // @TODO: const styles = hooks.useStyles(getStyles);

  // @TODO: these don't have any horizontal margin
  return (
    <Accordion
      title={props.faq.question}
      // @TODO: subtitle: {props.faq.paidOnly && <PremiumBadge style={styles.premiumBadgeFaq} />}
      onChange={(expanded) => {
        if (expanded) {
          fb.logEvent(fb.analytics, 'read_faq', {question: props.faq.question.replaceAll(/[^A-Za-z ]/g, '').replaceAll(' ', '_').toLowerCase()});
        }
      }}
    >
      {props.faq.answer}
    </Accordion>
  );
};

class FaqProps {
  faq: any;
  index: number;
  section: any;
};

export default Faq;
